import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-152">
      <div className="max-w-4xl mx-auto text-center" data-id="element-153">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-154">
          <span className="text-4xl" data-id="element-155">🧘‍♀️</span> YOGA PRONTA
        </div>

        <p className="text-white/80 text-sm tracking-wider mb-2 uppercase" data-id="element-156">
          EduLabs Italia
        </p>

        <p className="text-white/90 text-lg leading-relaxed mb-10 max-w-xl mx-auto font-medium" data-id="element-157">
          Strumenti di eccellenza per professionisti del movimento.
        </p>

        <div className="flex items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-158">
          <span className="flex items-center gap-2" data-id="element-159">
            <span data-id="element-160">📧</span> supporto.yogapronta@gmail.com
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-161" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-162">
          © YOGA PRONTA 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}